module.exports = __webpack_public_path__ + "static/p08_cerditoTopCabeza-778b569c76c6aa898b6b58a4c59aa4ce.png";